<template>
	<div>
        <q-list separator highlight link>
            <q-item
                v-for="(question, index) in questions"
                :key="index"
                @click.native="showQuestion(question)"
            >
                <q-item-main
                    :label="question.title"
                    label-lines="1"
                    :sublabel="`${$t('user_answers')}: ${question.qty_user_answered}`"
                    sublabel-lines="1"
                />
            </q-item>
        </q-list>
		<user-answers
			:question="question"
			:show_question="show_question"
			:title="title"
			:id="id"
			@hide_user_answers="hideUserAnswers"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserAnswers from 'components/admin/drills/report/UserAnswers'

export default {
	props: ['load', 'id', 'status', 'title'],

	components: {
		'user-answers': UserAnswers,
	},

	data() {
		return {
			questions: [],
			question: {},
			show_question: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_drills/drills/${this.id}/drill_report_questions/`, this.getHeader)
				.then((response) => {
					this.questions = response.data
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		showQuestion(question) {
			if (question.qty_user_answered > 0) {
				this.question = question
				this.show_question = true
			}
		},

		hideUserAnswers() {
			this.show_question = false
			this.question = {}
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				this.fetchData()
			}
		},
	},

	created() {
		this.fetchData()
	}
}
</script>

<style></style>
